import React from "react";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import i18n from "../../../../../i18n/i18n";
import {IOrderStore} from "../../../../stores/orderStore";
import {observer} from "mobx-react";
import {ValidatedValue} from "../../../../../helpers/validatedValue";

interface CostsSectionProps {
    isUpdate: boolean;
}

class CostsSection extends React.Component <CostsSectionProps> {
    static contextType = storesContext;

    render() {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.order.details.costs.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.order.details.costs.properties.paymentMethod")}
                            validatedValue={this.getPaymentMethod()}
                            testId="payment-method"
                            disabled={true}
                        />
                        {this.props.isUpdate && (
                            <>
                                <TextInput
                                    label={i18n.t("transportation.order.details.costs.properties.paymentDocumentNumber")}
                                    validatedValue={orderStore.paymentDocumentNumber}
                                    testId="payment-document-number"
                                    offAutocomplete
                                />
                                <TextInput
                                    label={i18n.t("transportation.order.details.costs.properties.storageTime")}
                                    validatedValue={orderStore.storageTime}
                                    testId="storage-time"
                                    disabled
                                />
                            </>
                        )}
                    </Row>
                </div>
            </div>
        );
    }

    private getPaymentMethod() {
        const orderStore = this.context.orderStore as IOrderStore;

        return new ValidatedValue(orderStore.paymentMethod.value ? i18n.t(`paymentMethod.${orderStore.paymentMethod.value}`) : "");
    }
}

export default observer(CostsSection);